import "@reach/combobox/styles.css";

import { GetSelectedLayers, getSelectedWalk } from "./lib/preferences";
import React, { Component } from "react";

import { GoogleMap } from "@react-google-maps/api";
import MapCenter from "./MapCenter";
import MyLocation from "./components/MyLocation/MyLocation";
import Pins from "./components/Pin/Pins";
import PropTypes from "prop-types";
import getNearby from "./lib/getNearby";
import { logError } from "./lib/isDev";

// const defaultCenter = {
//   // Bang on top of Ye Olde Wattling
//   lat: 51.512912750027,
//   lng: -0.0935446757206416,
// };

// FIXME: Remove after testing
const defaultCenter = {
  lat: 51.51292109999999,
  lng: -0.08894309999999184,
};

const defaultZoom = 18;

// TODO: Make this a functional component
//  (componentDidUpdate should be easy to convert to useEffect, no dependency on prev/next props)
class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false, // set to true when a fetch is in progress
      idleEvent: null, // used to cancel `idle` event listener
      localGeo: false,
      myCenter: defaultCenter,
      mapCenter: defaultCenter,
      panning: false,
      timer: null, // fetch timer
      inStreetviewMode: false,
    };
    this.handleIdle = this.handleIdle.bind(this);
    this.makeFirstFetch = this.makeFirstFetch.bind(this);
    this.newCenter = this.newCenter.bind(this);
    this.newNearbyPlaces = this.newNearbyPlaces.bind(this);
    this.panToCenter = this.panToCenter.bind(this);
    this.panToCenterReset = this.panToCenterReset.bind(this);
    this.watch = this.watch.bind(this);
  }

  watch() {
    const { localGeo } = this.state;
    if (localGeo) {
      navigator.geolocation.watchPosition(this.newCenter, logError);
    }
  }

  renderWalk(selectedWalk) {
    const legs = selectedWalk.points;
    if (legs === undefined) {
      return;
    }
    const googleMap = window["google"];
    const { map } = this.state;

    const polyline = new googleMap.maps.Polyline({
      path: [],
      strokeColor: "#FF0000",
      strokeWeight: 3,
    });
    const bounds = new googleMap.maps.LatLngBounds();

    for (let i = 0; i < legs.length; i++) {
      const pt = new googleMap.maps.LatLng(
        parseFloat(legs[i].lat),
        parseFloat(legs[i].lon),
      );
      polyline.getPath().push(pt);
      bounds.extend(pt);
    }
    polyline.setOptions({ zIndex: 200 });

    polyline.setMap(map);
    map.fitBounds(bounds);
  }

  // coming from navigator.geolocation.watchPosition
  newCenter(loc) {
    const { latitude, longitude } = loc.coords;
    const { userHasPanned } = this.props;

    // set user center
    this.setState({
      myCenter: {
        lat: latitude,
        lng: longitude,
      },
    });

    // only set map center if the user has not manually panned
    if (!userHasPanned) {
      this.setState({
        mapCenter: {
          lat: latitude,
          lng: longitude,
        },
      });
    }

    // panToCenter will decide whether to pan based on whether the user
    // has manually panned
    this.panToCenter();
  }

  // when user stops manually panning the map, get places for
  // the new center
  handleIdle() {
    const { idleEvent, map } = this.state;
    const googleMap = window["google"];

    if (idleEvent !== null) googleMap.maps.event.removeListener(idleEvent);
    const latLng = map.getCenter();

    // console.log("handleIdle  " + latLng.lat() + " " + latLng.lng());

    this.setState({
      mapCenter: {
        lat: latLng.lat(),
        lng: latLng.lng(),
      },
      panning: false,
    });
    this.newNearbyPlaces();
  }

  setStreetviewMode(streetView) {
    console.log("Marker inStreetviewMode " + streetView);

    this.setState({
      inStreetviewMode: streetView,
    });
  }

  makeFirstFetch() {
    const { map, timer } = this.state;
    const { setIsFirstFetch, setUserHasPanned } = this.props;

    setIsFirstFetch(false);

    // prevent infowindows from opening
    map.addListener("click", (evt) => {
      evt.stop();
    });

    // if user manually pans the map, stop watching for new locations
    map.addListener("dragstart", () => {
      clearTimeout(timer);
      setUserHasPanned(true);
      this.setState({
        idleEvent: map.addListener("idle", this.handleIdle),
        panning: true,
      });
    });

    // get first set of places
    this.newNearbyPlaces(true);
  }

  panToCenterReset(coordinate) {
    const { map } = this.state;
    if (map) {
      this.setState({
        idleEvent: map.addListener("idle", this.handleIdle),
        panning: true,
      });
      console.log(coordinate.lat);
      console.log(coordinate.lng);
      map.panTo({
        lat: parseFloat(coordinate.lat),
        lng: parseFloat(coordinate.lng),
      });
    }
  }

  panToCenter() {
    const { myCenter, map } = this.state;
    const { userHasPanned } = this.props;
    const googleMap = window["google"];

    if (map && googleMap.maps && !userHasPanned) {
      this.setState({
        idleEvent: map.addListener("idle", this.handleIdle),
        panning: true,
      });
      map.panTo(new googleMap.maps.LatLng(myCenter.lat, myCenter.lng));
    }
  }

  // conditions under which we want to fetch new places:
  // 1. no setTimeout has been set
  // 2. not currently fetching
  // 3. either:
  //      user has panned
  //        ok to fetch right away
  //      user has not panned
  //        elapsed time since last fetch is greater than the fetch delay
  //        if not enough time has passed since the last fetch
  //            set a timeout to trigger a fetch once the remaining time has passed
  newNearbyPlaces(isFirstFetch) {
    const { fetching, mapCenter, timer } = this.state;
    const {
      fetchDelay,
      fetchRange,
      lastFetch,
      setLastFetch,
      setPlaces,
      userHasPanned,
    } = this.props;

    const now = Date.now();

    const doFetch = () => {
      this.setState({
        fetching: true,
      });
      clearTimeout(timer);

      setLastFetch(now);

      const sources = GetSelectedLayers();
      getNearby(mapCenter.lat, mapCenter.lng, fetchRange, sources)
        .then((json) => {
          if (json.query && json.query.pages) {
            setPlaces(json.query.pages);
          }
        })
        .catch(logError)
        .finally(() => {
          this.setState({
            fetching: false,
          });
        });
    };

    // bail early if we have a timer set or are currently doing a fetch
    if (timer || fetching) {
      return;
    }

    if (isFirstFetch) {
      doFetch();
    } else if (userHasPanned) {
      doFetch();
    } else {
      // convert to seconds to because fetchDelay is saved in seconds
      const elapsed = (now - lastFetch) / 1000;

      // elapsed time since last fetch is greater than the fetch delay
      if (elapsed > fetchDelay) {
        doFetch();
      }
      // not enough time has elapsed, so set a timer to fetch later
      else {
        // set timer for how much time is left, convert to milliseconds
        const remaining = (fetchDelay - elapsed) * 1000;

        this.setState({
          timer: setTimeout(() => {
            this.setState({
              timer: null,
            });
            doFetch();
          }, remaining),
        });
      }
    }
  }

  componentDidUpdate() {
    const { fetching, localGeo, map, panning, watcher } = this.state;
    const { apiLoaded, geo, userHasPanned, isFirstFetch } = this.props;
    const googleMap = window["google"];

    // should only ever fire once, on app load
    if (apiLoaded && map && googleMap.maps && isFirstFetch) {
      this.makeFirstFetch();
    }

    // start watching for location changes when the user grants
    // location access for the first time
    if (geo && !watcher && !localGeo) {
      this.setState({
        localGeo: true,
      });
      window.requestAnimationFrame(this.watch);
    }

    // this gets hit a lot, but is basically a no-op if a fetch is
    // in progress or pending
    if (localGeo && !userHasPanned && !panning && !fetching) {
      this.panToCenter();
    }
  }

  onGoogleApiLoaded(map, maps) {
    const { setApiLoaded } = this.props;
    this.setState({ map, maps });
    const paramview = map.getStreetView();
    window.google.maps.event.addListener(paramview, "visible_changed", () => {
      this.setStreetviewMode(paramview.getVisible());
    });
    setApiLoaded(true);
  }

  render() {
    const { myCenter } = this.state;
    const { geo, places, userHasPanned } = this.props;
    const mapCenterClassnames = userHasPanned
      ? "map-center active"
      : "map-center";

    const containerStyle = {
      width: "100%",
      height: "100%",
    };

    const selectedWalk = getSelectedWalk();

    return (
      <div className="Map-container">
        <GoogleMap
          mapContainerStyle={containerStyle}
          zoom={defaultZoom}
          center={defaultCenter}
          onLoad={(map) => this.onGoogleApiLoaded(map)}
          onIdle={() => this.handleIdle()}
          yesIWantToUseGoogleMapApiInternals
          options={{
            fullscreenControl: false,
          }}
        >
              <Pins
                places={places}
                selectedWalk={selectedWalk}
                setPlace={this.props.setPlace}
                setViewInfoOpen={this.props.setViewInfoOpen}
              />
          {geo && <MyLocation lat={myCenter.lat} lng={myCenter.lng} />}
        </GoogleMap>
        <MapCenter classNames={mapCenterClassnames} />
      </div>
    );
  }
}

Map.propTypes = {
  apiLoaded: PropTypes.any.isRequired,
  geo: PropTypes.any.isRequired,
  userHasPanned: PropTypes.any.isRequired,
  isFirstFetch: PropTypes.any.isRequired,
  places: PropTypes.any.isRequired,
  fetchDelay: PropTypes.any.isRequired,
  fetchRange: PropTypes.any.isRequired,
  lastFetch: PropTypes.any.isRequired,
  setLastFetch: PropTypes.any.isRequired,
  setPlaces: PropTypes.any.isRequired,
  setIsFirstFetch: PropTypes.func.isRequired,
  setUserHasPanned: PropTypes.func.isRequired,
  setPlace: PropTypes.func.isRequired,
  setViewInfoOpen: PropTypes.any.isRequired,
  setApiLoaded: PropTypes.func.isRequired,
};

export default Map;
